import type { I18nKey } from '@/i18n/translations';

const BOSS_NAME_KEYS: Record<string, I18nKey> = {
  'stone-king': 'boss.stone_king',
  'frost-empress': 'boss.frost_empress',
  'storm-roc': 'boss.storm_roc',
  'abyss-kraken': 'boss.abyss_kraken',
  'verdant-colossus': 'boss.verdant_colossus',
  'inferno-wyrm': 'boss.inferno_wyrm',
  'eclipse-sovereign': 'boss.eclipse_sovereign',
};

const BOSS_DESCRIPTION_KEYS: Record<string, I18nKey> = {
  'stone-king': 'boss.stone_king_description',
  'frost-empress': 'boss.frost_empress_description',
  'storm-roc': 'boss.storm_roc_description',
  'abyss-kraken': 'boss.abyss_kraken_description',
  'verdant-colossus': 'boss.verdant_colossus_description',
  'inferno-wyrm': 'boss.inferno_wyrm_description',
  'eclipse-sovereign': 'boss.eclipse_sovereign_description',
};

type Translate = (key: I18nKey, vars?: Record<string, string | number>) => string;

export function localizedBossName(
  t: Translate,
  boss: { slug?: string; name: string },
): string {
  const key = boss.slug ? BOSS_NAME_KEYS[boss.slug] : undefined;
  return key ? t(key) : boss.name;
}

export function localizedBossDescription(
  t: Translate,
  boss: { slug: string; description: string | null },
): string | null {
  const key = BOSS_DESCRIPTION_KEYS[boss.slug];
  return key ? t(key) : boss.description;
}
